module.exports = __webpack_public_path__ + "static/media/menuoptions.4350c14a.PNG";